import { Storage } from '@/enums/storage.enum';
import { config } from '@/utils/config';
/**
 * Mixin podglądu
 * Zawiera metody:
 *  - `getPreview(url)` - pobiera podgląd w html
 *  - `openPreviewModal()` - otwiera modal podglądu
 *  - `closePreviewModal()` - zamyka modal podglądu
 */
export const previewMixin = {
  data() {
    return {
      previewHTML: undefined,
      showPreviewModal: false
    };
  },
  methods: {
    // @vuese
    // Pobranie html'a podglądu
    getPreview(url, data = {}) {
      return this.fetchPreview(url, data).then(html => (this.previewHTML = html));
    },
    // @vuese
    // Request pobrania HTML
    fetchPreview(url, data = {}) {
      return fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...data, [config.tokenFormField]: localStorage.getItem(Storage.TOKEN) })
      }).then(response => response.text());
    },
    // @vuese
    // Pokazanie modala z podglądem
    openPreviewModal() {
      this.showPreviewModal = true;
    },
    // @vuese
    // Ukrycie modala z podglądem
    closePreviewModal() {
      this.showPreviewModal = false;
    },
    // @vuese
    // Pobranie htmla do podglądu
    openPreview(data) {
      this.getPreview(this.previewUrl, data).then(() => this.openPreviewModal());
    }
  }
};
